/* ============================================================================
   DTF Studio — pro tools (hand-written; NOT generated). Adds to window.DTF / the builder:
     • DTF.review(onApprove)  the pre-cart review (replaces the sticker proof): one card per sheet being ordered with
                              a thumbnail, size, copies, price and a quality checklist; 'Print anyway' is required when
                              anything would print wrong; optional note for the press team → onApprove({ note }).
     • right-click menu       on the canvas: copies, fill, size, rotate, flip, align, background, enhance, fit, delete.
     • My designs             a tray of everything uploaded this session (one tile per design, the version in use),
                              click to add a copy to the active sheet at the size it was last used.
     • background pre-check   Basic / AI with nothing selected explains itself; on art that is already transparent it
                              asks first (removing it again roughens the edges).
     • resolution legend      a small key for the DPI colours while the Resolution view is on (desktop).
   Everything goes through DTF.kit(); every kit member is feature-detected so an older engine degrades gracefully.
   ========================================================================== */
(function () {
  'use strict';
  var K = null, booted = false;
  var RES0 = { optimal: 300, good: 250, bad: 200 };
  var BAND0 = { opt: ['#16a34a', 'Perfect'], good: ['#65a30d', 'Great'], fair: ['#d97706', 'OK'], low: ['#dc2626', 'Low'] };
  var RUL = 22; // the engine's ruler thickness (screen px)
  function sv(p, extra) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (extra || '1.9') + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
  var IC = {
    close: sv('<path d="M6 6l12 12M18 6L6 18"/>', '2.2'),
    ok: sv('<path d="M5 12l5 5 9-10"/>', '2.4'),
    warn: sv('<path d="M12 3l10 18H2z"/><path d="M12 10v5M12 18h.01"/>', '2.2'),
    copies: sv('<rect x="8" y="8" width="13" height="13" rx="1.5"/><path d="M16 8V4.5A1.5 1.5 0 0014.5 3h-10A1.5 1.5 0 003 4.5v10A1.5 1.5 0 004.5 16H8"/><path d="M14.5 12v6M11.5 15h6"/>'),
    fill: sv('<rect x="3" y="3" width="18" height="18" rx="1.5"/><rect x="6" y="6" width="4" height="4"/><rect x="14" y="6" width="4" height="4"/><rect x="6" y="14" width="4" height="4"/><rect x="14" y="14" width="4" height="4" stroke-dasharray="2 1.5"/>'),
    size: sv('<path d="M4 20L20 4M14 4h6v6M10 20H4v-6"/>'),
    cw: sv('<path d="M23 4v6h-6"/><path d="M20.5 15a9 9 0 1 1-2.1-9.4L23 10"/>'),
    fliph: sv('<path d="M12 3v18"/><path d="M8 7l-5 5 5 5V7zM16 7l5 5-5 5V7z"/>'),
    flipv: sv('<path d="M3 12h18"/><path d="M7 8l5-5 5 5H7zM7 16l5 5 5-5H7z"/>'),
    align: sv('<path d="M12 2v20"/><rect x="5" y="6" width="14" height="4" rx="1"/><rect x="8" y="14" width="8" height="4" rx="1"/>'),
    bg: sv('<path d="M3 21l11-11"/><path d="M15 3v3M15 12v3M9 9h3M18 9h3M17.2 6.8l1.8-1.8M12.8 6.8L11 5M17.2 11.2l1.8 1.8"/>'),
    enhance: sv('<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/><path d="M19 15l.8 1.7 1.7.8-1.7.8-.8 1.7-.8-1.7-1.7-.8 1.7-.8z"/>'),
    fit: sv('<path d="M8 3L3 6l2 5 2-1v11h10V10l2 1 2-5-5-3c-.5 1.7-2 3-4 3s-3.5-1.3-4-3z"/>'),
    del: sv('<path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/>'),
    lib: sv('<rect x="7" y="7" width="14" height="14" rx="1.5"/><path d="M4 17V5.5A1.5 1.5 0 015.5 4H17"/><circle cx="11.5" cy="11.5" r="1.3"/><path d="M21 17l-4-4-7 8"/>', '1.8'),
    up: sv('<path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><path d="M17 8l-5-5-5 5M12 3v12"/>'),
    nest: sv('<path d="M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z"/>'),
    all: sv('<rect x="3" y="3" width="18" height="18" rx="2" stroke-dasharray="3 2.5"/><path d="M8 12l3 3 5-6"/>')
  };

  // ── kit access (every member feature-detected) ────────────────────────────
  function kit() { if (!K && window.DTF && typeof window.DTF.kit === 'function') { try { K = window.DTF.kit(); } catch (e) { K = null; } } return K; }
  function fn(n) { var k = kit(); return k && typeof k[n] === 'function' ? k[n] : null; }
  function S() { var f = fn('S'); var s = f ? f() : null; return s || (window.SMN && window.SMN.state) || null; }
  function canvas() { var s = S(); return s && s.canvas ? s.canvas : null; }
  function Dst() { var f = fn('D'); try { return f ? f() : null; } catch (e) { return null; } }
  function RES() { var k = kit(); return (k && k.RES) || RES0; }
  function BAND() { var k = kit(); return (k && k.BAND) || BAND0; }
  function bandOf(d) { var r = RES(); d = Math.round(d); return d >= r.optimal ? 'opt' : d >= r.good ? 'good' : d >= r.bad ? 'fair' : 'low'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function el(h) { var d = document.createElement('div'); d.innerHTML = h.trim(); return d.firstChild; }
  function layer() { var f = fn('layer'); return f ? f() : (window.smnLayer ? window.smnLayer() : document.body); }
  function toast(m, t, a) { var f = fn('toast'); if (f) f(m, t, a); else if (window.SMNX && window.SMNX.toast) window.SMNX.toast(m, t, a); }
  function money(v) { var f = fn('money'); return f ? f(v) : '$' + (+v).toFixed(2); }
  function fin(v) { var f = fn('fin'); if (f) return f(v); v = Math.round(v * 100) / 100; return (v % 1 ? v.toFixed(2).replace(/0$/, '') : v.toFixed(0)) + '″'; }
  function mob() { return window.innerWidth <= 768; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : (many || one + 's')); }
  function isImg(o) { return !!o && o.type === 'image'; }
  function items() { var f = fn('items'); return f && canvas() ? f() : []; }
  function selected() { var f = fn('selected'); return f && canvas() ? f() : []; }
  function keyOf(o) { var f = fn('keyOf'); if (f) return f(o); var r = fn('recOf') ? kit().recOf(o) : null; return r ? r.key : (o._dtfKey || o.type); }
  function dpiOf(o) { var f = fn('dpiOf'); return f ? f(o) : Infinity; }
  function REG() { var k = kit(); return k && k.REG && typeof k.REG.get === 'function' ? k.REG : null; }
  function origLost(o) {
    var f = fn('origLost'); if (f) return !!f(o);
    if (!o || o.type !== 'image' || !o._dtfNat || o._dtfOrig) return false;
    var R = REG(), r = R ? R.get(o._dtfKey) : null; return !r || (!r.full && !r.fullUrl);
  }
  function dtfOn() { var D = Dst(); return document.documentElement.classList.contains('dtf-on') || !!(D && D.on); }
  // a long engine step (add to cart, nesting, sheet switch) is running: nothing may change the sheet under it
  function busy() { var f = fn('busy'), D = Dst(); try { return !!(f ? f() : D && (D.busy > 0 || D.loading)); } catch (e) { return false; } }
  function waitMsg() { toast('Wait for the current step to finish, then try again.', 'info'); }
  function domSheetCount() { return document.querySelectorAll('#dtfSheets .dtf-sh').length; }
  function save() { var smn = window.SMN; if (smn && smn.save) smn.save(); if (smn && smn.refreshBtns) smn.refreshBtns(); var f = fn('schedule'); if (f) f(); }
  function ptAnchor(x, y) { return { getBoundingClientRect: function () { return { left: x, right: x, top: y, bottom: y, width: 0, height: 0 }; } }; }

  // sheets (fallbacks cover an engine without the multi-sheet kit members)
  function activeIdx() { var D = Dst(); return D ? D.active : 0; }
  function sheetIdx() { var D = Dst(); if (!D || !D.sheets || !D.sheets.length) return [0]; return D.sheets.map(function (s, i) { return i; }); }
  function sheetCount(i) {
    var f = fn('sheetCount'); if (f) return f(i);
    if (i === activeIdx()) return items().length;
    var D = Dst(), sh = D && D.sheets[i]; return sh ? (sh.live && sh.live.length ? sh.live.length : (sh.json && sh.json.objects ? sh.json.objects.length : 0)) : 0;
  }
  function sheetName(i) { var f = fn('sheetName'); if (f) return f(i); var D = Dst(), sh = D && D.sheets[i]; return (sh && sh.name) || 'Sheet ' + (i + 1); }
  function sheetLen(i) {
    var f = fn('sheetLen'); if (f) return f(i);
    var k = kit(), D = Dst(); if (!D || i === D.active) return k.lenIn();
    var sh = D.sheets[i]; if (sh.size === 'custom') return Math.round(+sh.custom || 30);
    var m = /(\d+(?:\.\d+)?)$/.exec(sh.size || ''); return m ? +m[1] : 24;
  }
  function qtyOf(i) { var D = Dst(), s = S(); if (!D || i === D.active) return (s && s.qty) || 1; return (D.sheets[i] && D.sheets[i].qty) || 1; }
  function sheetObjects(i) {
    var f = fn('sheetObjects'); if (f) return Promise.resolve(f(i));
    if (i === activeIdx()) return Promise.resolve(items());
    var D = Dst(), sh = D && D.sheets[i], out = (sh && sh.live && sh.live.slice()) || [];
    if (!out.length && sh && sh.json && sh.json.objects && sh.json.objects.length) out.unavailable = true;
    return Promise.resolve(out);
  }
  function priceOf(len, q) { var f = fn('sheetPrice'); return f ? f(len, q).total : 0; }

  // ── popovers: one of ours at a time, registered with the engine's popover slot ──
  var cur = null, libWasOpen = false;
  function showPop(p, anchor, at) {
    closeMine();
    if (anchor && anchor.nodeType === 1 && !anchor.getClientRects().length) anchor = null; // hidden (phone toolstrip): centre it
    var sp = fn('setPop'), cp = fn('closePops');
    if (sp) sp(p); else if (cp) cp();
    layer().appendChild(p); p.hidden = false; p.style.removeProperty('display');
    if (at) placeAt(p, at.x, at.y);
    else if (fn('posPop')) kit().posPop(p, anchor);
    else { var r = anchor && anchor.getBoundingClientRect ? anchor.getBoundingClientRect() : { left: 16, bottom: 16, top: 16 }; placeAt(p, r.left, r.bottom + 6); }
    cur = p; p._opener = document.activeElement;
    return p;
  }
  function placeAt(p, x, y) {
    var w = p.offsetWidth || 220, h = p.offsetHeight || 200, vw = window.innerWidth, vh = window.innerHeight;
    var l = x + w > vw - 8 ? Math.max(8, x - w) : x, t = y + h > vh - 8 ? Math.max(8, y - h) : y;
    p.style.left = Math.max(8, l) + 'px'; p.style.top = Math.max(8, t) + 'px';
  }
  function closeMine(p, refocus) {
    p = p || cur; if (!p) return;
    if (p.parentNode) p.parentNode.removeChild(p);
    if (cur === p) cur = null;
    if (refocus && p._opener && p._opener.focus && document.contains(p._opener)) try { p._opener.focus({ preventScroll: true }); } catch (e) { }
  }
  function live(p) { return !!p && document.contains(p); }

  // ── 1) pre-cart review ────────────────────────────────────────────────────
  var rvOpen = null, lastNote = '';
  function row(r, key, st, text, focus) { r.rows.push({ key: key, st: st, text: text, focus: focus || null }); if (st === 'bad') r.bad++; else if (st === 'warn') r.warn++; }
  function problems(objs, len) {
    var k = kit(), p = null, f = fn('problemsOf');
    if (f) { try { p = f(objs, len); } catch (e) { console.warn('[dtf-pro] problemsOf', e); p = null; } }
    p = p ? { off: p.off || 0, overlap: p.overlap || 0, edge: p.edge, hits: p.hits || null } : { off: null, overlap: null, edge: null, hits: null };
    if ((p.off == null || p.edge == null) && fn('ibox')) {
      var off = 0, edge = 0, E = k.EDGE || 0.25, W = k.SW || 25;
      objs.forEach(function (o) {
        var b = k.ibox(o);
        if (b.x < -0.01 || b.y < -0.01 || b.x + b.w > W + 0.01 || b.y + b.h > len + 0.01) off++;
        else if (b.x < E - 0.01 || b.y < E - 0.01 || b.x + b.w > W - E + 0.01 || b.y + b.h > len - E + 0.01) edge++;
      });
      if (p.off == null) p.off = off; if (p.edge == null) p.edge = edge;
    }
    if (p.overlap == null) {
      var is = fn('issues') ? k.issues() : (window.DTF.issues ? window.DTF.issues() : null), n = 0;
      if (is && is.byObj) objs.forEach(function (o) { var x = is.byObj.get(o); if (x && x.overlap) n++; });
      p.overlap = n;
    }
    return { off: p.off || 0, overlap: p.overlap || 0, edge: p.edge || 0, hits: p.hits };
  }
  async function previewOf(objs, len) {
    var k = kit(), mp = Math.max(360, Math.ceil(len * 2)), f = fn('preview'); // long sheets keep a readable width
    if (f) return f(objs, len, mp, 'checker');
    if (!window.DTFPrint || !window.DTFPrint.drawSheet || !fn('mk')) return null;
    var WPI = k.WPI, SW = k.SW, sc = Math.min(mp / (SW * WPI), mp * 3 / (len * WPI)), cv = k.mk(SW * WPI * sc, len * WPI * sc), x = cv.getContext('2d');
    var pt = k.mk(16, 16), px = pt.getContext('2d'); px.fillStyle = '#fff'; px.fillRect(0, 0, 16, 16); px.fillStyle = '#e8ecf1'; px.fillRect(0, 0, 8, 8); px.fillRect(8, 8, 8, 8);
    x.fillStyle = x.createPattern(pt, 'repeat'); x.fillRect(0, 0, cv.width, cv.height);
    window.DTFPrint.drawSheet(x, objs, sc, 0, 0);
    return cv;
  }
  async function checkSheet(i) {
    var k = kit(), r = { i: i, len: sheetLen(i), qty: qtyOf(i), rows: [], bad: 0, warn: 0, n: 0, cv: null };
    var objs = [];
    try { objs = await sheetObjects(i) || []; } catch (e) { console.warn('[dtf-pro] sheet objects', e); r.err = true; }
    r.n = objs.length;
    if (r.err || objs.unavailable) { r.failed = true; row(r, 'load', 'bad', 'This sheet could not be checked — reload the page before ordering.'); return r; }
    var E = fin(k.EDGE || 0.25), p = problems(objs, r.len); r.hits = p.hits;
    row(r, 'overlap', p.overlap ? 'bad' : 'ok', p.overlap ? plural(p.overlap, 'design') + ' overlap — they would print on top of each other' : 'No overlapping designs', 'overlap');
    row(r, 'off', p.off ? 'bad' : 'ok', p.off ? plural(p.off, 'design is', 'designs are') + ' past the sheet edge — ' + (p.off === 1 ? 'it' : 'they') + ' would be cut off' : 'Nothing past the sheet edge', 'off');
    // a warning, as in the Check panel: only off-sheet and overlapping designs need "Print anyway"
    row(r, 'edge', p.edge ? 'warn' : 'ok', p.edge ? plural(p.edge, 'design is', 'designs are') + ' closer than ' + E + ' to the sheet edge — the very edge may not print' : 'Nothing in the ' + E + ' edge margin', 'edge');
    var imgs = objs.filter(isImg), worst = Infinity, lows = 0, fairs = 0;
    imgs.forEach(function (o) { var d = dpiOf(o); if (d < worst) worst = d; var b = bandOf(d); if (b === 'low') lows++; else if (b === 'fair') fairs++; });
    if (!imgs.length || !isFinite(worst)) row(r, 'dpi', 'ok', 'Vector and text — sharp at any size');
    else {
      var b = bandOf(worst), lab = (imgs.length > 1 ? 'Lowest resolution ' : 'Resolution ') + Math.round(worst) + ' DPI';
      if (b === 'opt') row(r, 'dpi', 'ok', lab + ' · ' + BAND().opt[1]);
      else if (b === 'good') row(r, 'dpi', 'ok', lab + ' · ' + BAND().good[1]);
      else if (b === 'fair') row(r, 'dpi', 'warn', lab + ' · ' + BAND().fair[1] + ' — ' + plural(fairs, 'design') + ' may look slightly soft up close', 'dpi_fair');
      else row(r, 'dpi', 'bad', lab + ' · ' + BAND().low[1] + ' — ' + plural(lows, 'design') + ' will print blurry', 'dpi_low');
    }
    if (imgs.length) {
      var semi = imgs.filter(function (o) { return o._dtfSemi > 0.04; }).length, box = imgs.filter(function (o) { return !!o._dtfBox; }).length;
      row(r, 'semi', semi ? 'warn' : 'ok', semi ? plural(semi, 'design has', 'designs have') + ' see-through glows or shadows — they print with a white haze' : 'No see-through pixels', 'semi');
      row(r, 'box', box ? 'bad' : 'ok', box ? plural(box, 'design has', 'designs have') + ' a solid background — it prints as a box' : 'No solid background boxes', 'box');
      var lost = objs.filter(origLost).length, R0 = REG(), upl = imgs.filter(function (o) { var q = R0 && R0.get(o._dtfKey); return q && q.uploading && !q.fullUrl; }).length;
      row(r, 'orig', lost ? 'bad' : 'ok', lost ? plural(lost, 'full-resolution original was', 'full-resolution originals were') + ' never uploaded — re-upload before ordering' : upl ? 'Full-resolution originals uploading — we’ll finish before adding to the cart' : 'Full-resolution originals ready', 'orig');
    }
    if (objs.missing) { r.failed = true; row(r, 'load', 'bad', plural(objs.missing, 'design') + ' did not load — reload the page before ordering'); }
    var WPI = k.WPI || 40, tiny = objs.filter(function (o) { return /text/.test(o.type) && (o.fontSize || 0) * Math.abs(o.scaleY || 1) / WPI * 72 < 7; }).length;
    if (tiny) row(r, 'tiny', 'warn', plural(tiny, 'text item') + ' under 7 pt — may not hold on the shirt', 'tiny');
    try { r.cv = await previewOf(objs, r.len); if (r.cv) marks(r.cv, objs, r.len, r); } catch (e) { console.warn('[dtf-pro] preview', e); }
    if (!r.cv) { r.failed = true; row(r, 'preview', 'bad', 'The print preview could not load — reload before ordering.'); }
    r.objs = objs;
    return r;
  }
  // red outlines on the preview for designs that would print wrong, by the same tests as the rows (the ink past the
  // edge, overlapping on any sheet, under 200 DPI, a solid background box, a missing original); amber: in the edge margin
  function marks(cv, objs, len, r) {
    var k = kit(); if (!k || !fn('wbox')) return;
    var WPI = k.WPI || 40, SW = k.SW || 25, E = k.EDGE || 0.25, sc = cv.width / (SW * WPI), x = cv.getContext('2d'), ink = fn('inkRect');
    var hits = r && r.hits, is = !hits && r && r.i === activeIdx() && fn('issues') ? k.issues() : null, by = is && is.byObj;
    x.save(); x.strokeStyle = '#ef4444'; x.lineWidth = Math.max(2, cv.width / 220); x.setLineDash([Math.max(4, cv.width / 90), Math.max(3, cv.width / 140)]);
    objs.forEach(function (o) {
      var q = null; if (ink) try { q = ink(o); } catch (e) { q = null; }
      var b = q ? { l: q.x * WPI, t: q.y * WPI, r: (q.x + q.w) * WPI, b: (q.y + q.h) * WPI } : k.wbox(o), l = b.l / WPI, t = b.t / WPI, rt = b.r / WPI, bt = b.b / WPI, f = by ? by.get(o) : null;
      var bad = l < -0.01 || t < -0.01 || rt > SW + 0.01 || bt > len + 0.01 || (hits ? hits.indexOf(o) > -1 : !!(f && (f.overlap || f.off))) || (isImg(o) && (bandOf(dpiOf(o)) === 'low' || !!o._dtfBox)) || origLost(o);
      var near = !bad && (l < E - 0.01 || t < E - 0.01 || rt > SW - E + 0.01 || bt > len - E + 0.01 || !!(f && f.edge)); // a warning: amber
      if (bad || near) { x.strokeStyle = bad ? '#ef4444' : '#f59e0b'; x.strokeRect(b.l * sc, b.t * sc, (b.r - b.l) * sc, (b.b - b.t) * sc); }
    });
    x.restore();
  }
  // click a preview: the same sheet large enough to really check it (one at a time; focus goes back to its button)
  var bigBusy = false;
  async function bigView(r, opener) {
    var k = kit(); if (!r || !r.objs || bigBusy || document.querySelector('.dtf-rv-big')) return;
    bigBusy = true;
    var cv = null; try { cv = fn('preview') ? await k.preview(r.objs, r.len, Math.min(1400, Math.max(700, window.innerWidth - 80)), 'checker') : null; } catch (e) { cv = null; }
    if (!cv || !live(rvOpen)) { bigBusy = false; return; }
    marks(cv, r.objs, r.len, r);
    var ov = el('<div class="dtf-rv-big" role="dialog" aria-modal="true" aria-label="' + esc(sheetName(r.i)) + ' preview"><div class="dtf-rv-big-h"><b>' + esc(sheetName(r.i)) + ' · ' + (k.SW || 25) + ' × ' + r.len + ' in</b><span>Red outline = needs fixing · amber = check it</span><button type="button" data-x aria-label="Close">' + IC.close + '</button></div><div class="dtf-rv-big-b"></div></div>');
    ov.querySelector('.dtf-rv-big-b').appendChild(cv);
    layer().appendChild(ov);
    // its own focus trap: the review behind it is inert until it closes (the review's keys stand aside while it is open)
    var rv = rvOpen; rv.inert = true;
    function shut(e) { if (e) { e.stopPropagation(); e.preventDefault(); } document.removeEventListener('keydown', onK, true); if (ov.parentNode) ov.parentNode.removeChild(ov); bigBusy = false; rv.inert = false;
      var f = opener && document.contains(opener) ? opener : rvOpen && live(rvOpen) ? rvOpen.querySelector('#dtfRvT') : null; if (f) try { f.focus({ preventScroll: true }); } catch (e3) { } }
    function onK(e) {
      if (e.key === 'Escape') return shut(e);
      if (e.key === 'Tab') { e.preventDefault(); var fs = Array.prototype.slice.call(ov.querySelectorAll('button, [tabindex]:not([tabindex="-1"])')), i = fs.indexOf(document.activeElement); if (fs.length) fs[i < 0 ? 0 : (i + (e.shiftKey ? fs.length - 1 : 1)) % fs.length].focus(); }
      e.stopPropagation();
    }
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('[data-x]')) shut(); });
    document.addEventListener('keydown', onK, true);
    var xb = ov.querySelector('[data-x]'); try { xb.focus({ preventScroll: true }); } catch (e2) { }
  }
  function cardHead(i) {
    var k = kit(), len = sheetLen(i), q = qtyOf(i), n = sheetCount(i);
    return '<div class="dtf-rv-h"><b>' + esc(sheetName(i)) + '</b><span>' + (k.SW || 25) + ' × ' + len + ' in · ×' + q + '</span><em>' + money(priceOf(len, q)) + '</em></div>' +
      '<div class="dtf-rv-sub">' + plural(n, 'design') + (q > 1 ? ' · ' + q + ' copies of this sheet' : ' · 1 copy') + '</div>';
  }
  function rowHtml(x) { return '<li class="dtf-rv-li ' + x.st + '">' + (x.st === 'ok' ? IC.ok : x.st === 'bad' ? IC.close : IC.warn) + '<span><span class="dtf-sr">' + (x.st === 'ok' ? 'Passed: ' : x.st === 'bad' ? 'Problem: ' : 'Warning: ') + '</span>' + esc(x.text) + '</span></li>'; }
  function fillCard(card, r) {
    var th = card.querySelector('.dtf-rv-th'); th.innerHTML = '';
    if (r.cv) {
      r.cv.setAttribute('role', 'img'); r.cv.setAttribute('aria-label', 'Preview of ' + sheetName(r.i)); th.appendChild(r.cv);
      var zb = el('<button type="button" class="dtf-rv-zoom" title="View this sheet large">View large</button>'); th.appendChild(zb);
      th.onclick = function (e) { e.stopPropagation(); bigView(r, zb); };
    }
    else th.innerHTML = '<span class="dtf-rv-nop">No preview</span>';
    card.querySelector('.dtf-rv-list').innerHTML = r.rows.map(rowHtml).join('');
    card.classList.toggle('bad', !!r.bad); card.classList.toggle('warn', !r.bad && !!r.warn);
  }
  function review(onApprove, onCancel) {
    if (rvOpen && live(rvOpen)) { var fb = rvOpen.querySelector('[data-rv="go"]'); if (fb) fb.focus(); return; }
    var k = kit();
    if (!k) { toast('The print review is not ready. Reload the studio and try again.', 'warn'); if (typeof onCancel === 'function') onCancel(); return; }
    // an engine without the sheets kit can only show the open sheet: use the old proof rather than approve part of the order
    if (!Dst() && domSheetCount() > 1 && typeof window._sl2Proof === 'function') return window._sl2Proof(function () { if (typeof onApprove === 'function') onApprove({ note: '' }); });
    closeMine(); if (fn('closePops')) k.closePops();
    var c = canvas(); if (c) { c.discardActiveObject(); c.requestRenderAll(); }
    var idx = sheetIdx().filter(function (i) { return sheetCount(i) > 0; });
    if (!idx.length) return toast('Add designs to your sheet first', 'warn');
    var prev = document.activeElement, closed = false, approved = false, ready = false, gated = false, results = [];
    // designs that didn't fit (left-overs) are on no sheet: a problem that needs "Print anyway", with the one-click fix
    var D0 = Dst(), ovN = D0 && D0.overflow ? D0.overflow.length : 0, them = ovN > 1 ? 'them' : 'it';
    var m = el('<div class="dtf-modal dtf-modal-wide dtf-rv-modal" id="dtfReview" role="dialog" aria-modal="true" aria-labelledby="dtfRvT" aria-describedby="dtfRvLead">' +
      '<div class="dtf-mbox"><div class="dtf-mh"><b id="dtfRvT">Review your gang sheet' + (idx.length > 1 ? 's' : '') + '</b><button type="button" data-rv="x" aria-label="Close">' + IC.close + '</button></div>' +
      '<div class="dtf-mb dtf-rv"><p class="dtf-rv-lead" id="dtfRvLead">This is exactly what we’ll print. Check ' + (idx.length > 1 ? 'every sheet' : 'your sheet') + ' before it goes to the press.</p>' +
      (ovN ? '<div class="dtf-rv-over" role="alert">' + IC.warn + '<span><b><span class="dtf-sr">Problem: </span>' + plural(ovN, 'design') + ' didn’t fit and ' + (ovN > 1 ? 'aren’t' : 'isn’t') + ' on any sheet</b>' + (ovN > 1 ? 'They' : 'It') + ' won’t be printed or charged unless you put ' + them + ' on a sheet.</span><button type="button" class="dtf-btn dtf-primary" data-rv="over">Put ' + them + ' on a new sheet</button></div>' : '') +
      '<div class="dtf-rv-cards">' + idx.map(function (i) {
        return '<section class="dtf-rv-card" data-rvi="' + i + '" aria-label="' + esc(sheetName(i)) + '"><div class="dtf-rv-th"><span class="dtf-busy"><i></i></span></div><div class="dtf-rv-body">' + cardHead(i) +
          '<ul class="dtf-rv-list"><li class="dtf-rv-li wait"><span class="dtf-busy"><i></i>Checking…</span></li></ul></div></section>';
      }).join('') + '</div>' +
      '<label class="dtf-rv-note"><span>Note for our press team <em>optional</em></span><textarea id="dtfRvNote" maxlength="500" rows="2" placeholder="Anything we should know? e.g. “Print sheet 2 first” or “The white box around the logo is intentional.”"></textarea><small id="dtfRvCnt" aria-live="polite">0 / 500</small></label>' +
      '</div>' +
      '<div class="dtf-rv-foot"><label class="dtf-rv-ack" id="dtfRvAck" hidden><input type="checkbox" id="dtfRvOk"><span><b>Print anyway — I accept these issues</b><small>We’ll print the sheets exactly as shown above.</small></span></label>' +
      '<div class="dtf-rv-bar"><span class="dtf-rv-tot" id="dtfRvTot"><span class="dtf-busy"><i></i>Checking your sheets…</span></span>' +
      '<button type="button" class="dtf-btn" data-rv="back">Back to editor</button><button type="button" class="dtf-btn dtf-primary" data-rv="go" aria-disabled="true">Add to cart</button></div></div></div></div>');
    layer().appendChild(m); m.style.removeProperty('display'); rvOpen = m;
    var note = m.querySelector('#dtfRvNote'), cnt = m.querySelector('#dtfRvCnt'), ack = m.querySelector('#dtfRvAck'), okBox = m.querySelector('#dtfRvOk');
    var go = m.querySelector('[data-rv="go"]'), back = m.querySelector('[data-rv="back"]'), tot = m.querySelector('#dtfRvTot');
    note.value = lastNote || ''; cnt.textContent = note.value.length + ' / 500';
    function setGo() { var on = ready && (!gated || okBox.checked); go.setAttribute('aria-disabled', on ? 'false' : 'true'); }
    function close(ok) {
      if (closed) return; closed = true; if (rvOpen === m) rvOpen = null;
      lastNote = note.value; // kept until the order is really in the cart (DTF.noteSent), so a failed add keeps it
      document.removeEventListener('keydown', onKey, true);
      if (m.parentNode) m.parentNode.removeChild(m);
      if (!ok) {
        if (typeof onCancel === 'function') try { onCancel(); } catch (e) { console.warn('[dtf-pro] review cancel', e); }
        if (prev && prev.focus && document.contains(prev)) try { prev.focus({ preventScroll: true }); } catch (e2) { }
      }
    }
    function approve() {
      if (approved || closed || go.getAttribute('aria-disabled') === 'true') {
        if (ready && gated && !okBox.checked) { ack.classList.remove('dtf-rv-need'); void ack.offsetWidth; ack.classList.add('dtf-rv-need'); okBox.focus(); }
        return;
      }
      approved = true;
      var txt = String(note.value || '').replace(/\r\n?/g, '\n').replace(/\n{3,}/g, '\n\n').trim().slice(0, 500);
      // what the customer saw and accepted, per sheet index (problems need the 'Print anyway' tick): kept on the order for the press team
      var acc = {};
      results.forEach(function (r) { var t = r.rows.filter(function (x) { return x.st === 'bad'; }).concat(r.rows.filter(function (x) { return x.st === 'warn'; })).map(function (x) { return x.text; }); if (t.length) acc[r.i] = (r.bad ? 'Print anyway ticked: ' : 'Approved with warnings: ') + t.join('; '); });
      close(true);
      if (typeof onApprove === 'function') { try { onApprove({ note: txt, accepted: acc }); } catch (e) { console.error('[dtf-pro] review approve', e); } }
    }
    function focusables() { return Array.prototype.slice.call(m.querySelectorAll('button, textarea, input, [tabindex]:not([tabindex="-1"])')).filter(function (x) { return !x.disabled && x.offsetParent !== null; }); }
    function onKey(e) {
      if (closed || document.querySelector('.dtf-rv-big')) return; // the big view handles its own keys
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(false); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var a = document.activeElement, i = f.indexOf(a);
        if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
      }
      e.stopPropagation(); // the builder's shortcuts (Delete, arrows, undo) stay off while the review is open
    }
    document.addEventListener('keydown', onKey, true);
    note.addEventListener('input', function () { cnt.textContent = note.value.length + ' / 500'; });
    okBox.addEventListener('change', function () { ack.classList.remove('dtf-rv-need'); setGo(); });
    m.addEventListener('click', function (e) {
      if (e.target === m) return close(false);
      var b = e.target.closest('[data-rv]'); if (!b) return;
      var a = b.dataset.rv;
      if (a === 'x' || a === 'back') return close(false);
      if (a === 'fix') { close(false); return fixFirst(results); }
      if (a === 'over') {
        // the left-overs go on a new sheet, then the review opens again with it
        close(false);
        var put = window.DTF && window.DTF.overflowToSheet;
        if (put) Promise.resolve(put()).then(function () { var D1 = Dst(); if (D1 && !(D1.overflow && D1.overflow.length)) review(onApprove, onCancel); });
        return;
      }
      if (a === 'go') approve();
    });
    var ttl = m.querySelector('#dtfRvT'); ttl.setAttribute('tabindex', '-1');
    try { ttl.focus({ preventScroll: true }); } catch (e) { ttl.focus(); }
    (async function run() {
      for (var n = 0; n < idx.length; n++) {
        if (closed) return;
        var r; try { r = await checkSheet(idx[n]); } catch (e) { console.warn('[dtf-pro] check', e); r = { i: idx[n], len: sheetLen(idx[n]), qty: qtyOf(idx[n]), rows: [], bad: 0, warn: 0, failed: true }; row(r, 'load', 'bad', 'This sheet could not be checked — reload the page before ordering.'); }
        if (closed) return;
        results.push(r); fillCard(m.querySelector('[data-rvi="' + idx[n] + '"]'), r);
      }
      var anyBad = results.some(function (x) { return x.bad; }), anyWarn = results.some(function (x) { return x.warn; });
      var pr = null; try { pr = window.DTF.price ? window.DTF.price() : null; } catch (e) { pr = null; }
      var total = pr && isFinite(pr.total) ? pr.total : results.reduce(function (a, x) { return a + priceOf(x.len, x.qty); }, 0);
      var prints = results.reduce(function (a, x) { return a + (x.qty || 1); }, 0);
      tot.innerHTML = 'Total <b>' + money(total) + '</b> · ' + plural(results.length, 'sheet') + (prints > results.length ? ' · ' + prints + ' printed' : '');
      go.textContent = 'Add to cart · ' + money(total);
      if (anyBad || anyWarn) { back.textContent = 'Go back and fix'; back.dataset.rv = 'fix'; }
      var failed = results.some(function (x) { return x.failed; });
      gated = anyBad || ovN > 0; ack.hidden = !gated || failed; ready = !failed; setGo();
      if (failed) go.textContent = 'Review unavailable — reload';
    })();
    return m;
  }
  // close the review, open the first sheet with problems and point at them (the Check panel row does the selecting)
  function fixFirst(results) {
    var t = null, key = null;
    results.forEach(function (r) { if (!t && r.bad) t = r; });
    if (!t) results.forEach(function (r) { if (!t && r.warn) t = r; });
    if (!t) return;
    t.rows.forEach(function (x) { if (!key && x.st === (t.bad ? 'bad' : 'warn')) key = x.focus; });
    var act = fn('activate') || (window.DTF && window.DTF.activate), p = t.i !== activeIdx() && act ? Promise.resolve(act(t.i)) : Promise.resolve();
    p.then(function () { setTimeout(function () { focusCheck(key); }, 220); });
  }
  function objsFor(key, its) {
    var is = fn('issues') ? kit().issues() : (window.DTF.issues ? window.DTF.issues() : null), by = is && is.byObj;
    return its.filter(function (o) {
      var x = by ? by.get(o) : null;
      if (key === 'overlap' || key === 'off' || key === 'edge') return !!(x && x[key]);
      if (key === 'dpi_low') return isImg(o) && bandOf(dpiOf(o)) === 'low';
      if (key === 'dpi_fair') return isImg(o) && bandOf(dpiOf(o)) === 'fair';
      if (key === 'semi') return isImg(o) && o._dtfSemi > 0.04;
      if (key === 'box') return isImg(o) && !!o._dtfBox;
      if (key === 'orig') return origLost(o);
      if (key === 'tiny') return !!(x && x.tiny);
      return false;
    });
  }
  function focusCheck(key) {
    if (window.DTF && window.DTF.runChecks) try { window.DTF.runChecks(); } catch (e) { }
    var rowEl = key ? document.querySelector('#dtfCheck .dtf-ck-row[data-ck="' + key + '"]') : null;
    if (rowEl) {
      rowEl.click();
      if (!mob() && rowEl.scrollIntoView) try { rowEl.scrollIntoView({ block: 'nearest' }); } catch (e) { }
      rowEl.classList.remove('dtf-rv-flash'); void rowEl.offsetWidth; rowEl.classList.add('dtf-rv-flash');
      setTimeout(function () { rowEl.classList.remove('dtf-rv-flash'); }, 1800);
      return;
    }
    var c = canvas(), os = key ? objsFor(key, items()) : []; if (!c || !os.length) return;
    c.discardActiveObject(); c.setActiveObject(os.length > 1 ? new fabric.ActiveSelection(os, { canvas: c }) : os[0]);
    if (window.DTF.ensureVisible) window.DTF.ensureVisible(os[0]); c.requestRenderAll();
  }

  // ── 2) right-click menu on the canvas ─────────────────────────────────────
  function onContext(e) {
    var c = canvas(); if (!c || !c.upperCanvasEl || e.target !== c.upperCanvasEl || !dtfOn()) return;
    var a = c.getActiveObject(); if (a && a.isEditing) return; // editing text keeps the browser's own menu (copy / paste)
    e.preventDefault(); e.stopPropagation();
    if (busy() || document.querySelector('.dtf-modal')) return;
    var t = null; try { t = c.findTarget(e, false); } catch (er) { t = null; }
    if (t && t.type !== 'activeSelection' && (items().indexOf(t) < 0 || t.selectable === false)) t = null;
    if (t && t.type !== 'activeSelection' && selected().indexOf(t) < 0) { c.discardActiveObject(); c.setActiveObject(t); c.requestRenderAll(); }
    else if (!t && c.getActiveObject()) { c.discardActiveObject(); c.requestRenderAll(); }
    openCtx(e.clientX, e.clientY);
  }
  function openCtx(x, y) {
    var sel = selected(), one = sel.length === 1 ? sel[0] : null, img = isImg(one), h = '';
    function it(k, ic, label, cls, kbd) { return '<button type="button" role="menuitem" data-cx="' + k + '"' + (cls ? ' class="' + cls + '"' : '') + '>' + ic + '<span>' + label + '</span>' + (kbd ? '<kbd>' + kbd + '</kbd>' : '') + '</button>'; }
    var sep = '<div class="dtf-ctx-sep" role="separator"></div>';
    if (sel.length) {
      var head = one ? (one._dtfName || (one.text ? String(one.text).split('\n')[0] : 'Design')) : plural(sel.length, 'design') + ' selected';
      if (one && fn('sizeOf')) { try { var s = kit().sizeOf(one); head += ' · ' + fin(s.w) + ' × ' + fin(s.h); } catch (e0) { } }
      h += '<div class="dtf-ctx-h">' + esc(String(head).slice(0, 48)) + '</div>';
      h += it('copies', IC.copies, 'Copies…') + it('fill', IC.fill, 'Fill with this') + (one ? it('size', IC.size, 'Size…') : '') + sep;
      h += it('rotate', IC.cw, 'Rotate 90°') + it('fliph', IC.fliph, 'Flip horizontal') + it('flipv', IC.flipv, 'Flip vertical') + it('align', IC.align, 'Align…');
      var extra = (img ? it('bg', IC.bg, 'Remove background') : '') + (img && Math.round(dpiOf(one)) < RES().optimal && window.DTF.enhance ? it('enhance', IC.enhance, 'Enhance') : '') + (one && window.DTF.openFit ? it('fit', IC.fit, 'Fit check') : '');
      if (extra) h += sep + extra;
      h += sep + it('del', IC.del, 'Delete', 'dtf-ctx-del', 'Del');
    } else {
      var any = items().length;
      h += it('up', IC.up, 'Upload designs…') + it('lib', IC.lib, 'My designs…') + (any ? sep + it('nest', IC.nest, 'Auto-nest this sheet') + it('all', IC.all, 'Select all') : '');
    }
    var p = el('<div class="dtf-pop dtf-ctx" role="menu" aria-label="' + (sel.length ? 'Design actions' : 'Sheet actions') + '">' + h + '</div>');
    showPop(p, null, { x: x, y: y });
    var first = p.querySelector('button'); if (first) try { first.focus({ preventScroll: true }); } catch (e1) { }
    p.addEventListener('contextmenu', function (ev) { ev.preventDefault(); });
    p.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-cx]'); if (!b) return;
      closeMine(p); runCtx(b.dataset.cx, ptAnchor(x, y));
    });
  }
  function clickEl(sel) { var b = document.querySelector(sel); if (b) { b.click(); return true; } return false; }
  function runCtx(a, anchor) {
    var k = kit(), D = window.DTF;
    if (a === 'copies') { if (fn('openCopies')) k.openCopies(anchor); else clickEl('#dtfBtnDupe'); }
    else if (a === 'fill') { if (fn('fill')) k.fill(); else if (D.fill) D.fill(); }
    else if (a === 'size') { if (fn('openSize')) k.openSize(anchor); else clickEl('#dtfBtnSize'); }
    else if (a === 'rotate') { if (fn('turn')) k.turn(90); else if (D.turn) D.turn(90); }
    else if (a === 'fliph' || a === 'flipv') { var f = a === 'fliph' ? 'flipX' : 'flipY'; if (fn('flip')) k.flip(f); else if (D.flip) D.flip(f); }
    else if (a === 'align') { if (fn('openAlign')) k.openAlign(anchor); else clickEl('#dtfSel [data-sel="align"]'); }
    else if (a === 'bg') { bgAnchor = anchor; if (!clickEl('.sms-tool-icon[data-bg="pro"]')) toast('Background removal isn’t available here', 'warn'); bgAnchor = null; }
    else if (a === 'enhance') { if (D.enhance) D.enhance(selected()); }
    else if (a === 'fit') { if (D.openFit) D.openFit(); }
    else if (a === 'del') removeSel();
    else if (a === 'up') { if (D.pickFiles) D.pickFiles(); else clickEl('#btnAddImage'); }
    else if (a === 'lib') openLib(anchor);
    else if (a === 'nest') { if (fn('autoNest')) k.autoNest(); else if (D.autoNest) D.autoNest(); }
    else if (a === 'all') selectAll();
  }
  function removeSel() {
    var c = canvas(), sel = selected(); if (!c || !sel.length) return;
    c.discardActiveObject(); sel.forEach(function (o) { c.remove(o); }); c.requestRenderAll(); save();
  }
  function selectAll() {
    var c = canvas(), its = items().filter(function (o) { return o.selectable !== false; }); if (!c || !its.length) return;
    c.discardActiveObject(); c.setActiveObject(its.length > 1 ? new fabric.ActiveSelection(its, { canvas: c }) : its[0]); c.requestRenderAll();
  }

  // ── 3) My designs ─────────────────────────────────────────────────────────
  function usable(r) { var e = r && r.el; return !!(r && r.url && r.nat && r.nat[0] > 0 && e && (e.naturalWidth || e.width)); }
  // one family per uploaded design: the original plus every version made from it (background removal, halftone, …)
  function families() {
    var R = REG(); if (!R) return [];
    var fam = {}, order = [];
    function rootOf(r) { var g = 0; while (r && r.from && r.from.key && R.get(r.from.key) && g++ < 24) r = R.get(r.from.key); return r; }
    R.forEach(function (r) {
      if (!r || !r.key) return;
      var root = rootOf(r); if (!root) return;
      if (!fam[root.key]) { fam[root.key] = { root: root, recs: [] }; order.push(root.key); }
      fam[root.key].recs.push(r);
    });
    return order.reverse().map(function (k) { return fam[k]; }).filter(function (f) { return f.recs.some(usable); });
  }
  // the version to add: the one used most on this sheet, then anywhere, else the original (an enhanced version wins a tie)
  function enhOf(r) { return r ? r._enh || (r.from && r.from.bg === 'enhance' ? 1 : 0) : 0; }
  function pickRec(f) {
    var its = items(), cw = fn('copyWidths'), best = null, bestN = -1;
    f.recs.forEach(function (r) {
      if (!usable(r)) return;
      var here = its.filter(function (o) { return o._dtfKey === r.key; }).length, any = 0;
      if (!here && cw) { try { any = cw(r.key).length; } catch (e) { any = 0; } }
      var n = here * 1000 + any;
      if (n > bestN || (n === bestN && enhOf(r) && !enhOf(best))) { bestN = n; best = r; }
    });
    return best;
  }
  function sibling(key) {
    var its = items(); for (var i = 0; i < its.length; i++) if (its[i]._dtfKey === key) return its[i];
    var D = Dst(); if (!D || !D.sheets) return null;
    for (var s = 0; s < D.sheets.length; s++) {
      if (s === D.active) continue;
      var sh = D.sheets[s], list = (sh.live && sh.live.length ? sh.live : (sh.json && sh.json.objects) || []);
      for (var j = 0; j < list.length; j++) if (list[j]._dtfKey === key) return list[j];
    }
    return null;
  }
  function widthFor(rec) {
    var k = kit(), sib = sibling(rec.key);
    if (sib && sib.getScaledWidth && fn('sizeIn')) return k.sizeIn(sib).w;
    if (sib && sib.width && sib.scaleX) return Math.abs(sib.width * sib.scaleX) / (k.WPI || 40);
    return null;
  }
  function defaultWidth(rec) {
    var k = kit(), nl = Math.max(rec.nat[0], rec.nat[1]), E = k.EDGE || 0.25, pw = fn('printableW') ? k.printableW() : 24.5;
    var want = rec.phys ? Math.min(rec.phys, (k.MAXLEN || 360) - 2 * E) : fn('autoIn') ? k.autoIn(rec) : Math.max(Math.max(0.5, Math.min(1.5, nl / RES().good)), Math.min(11, nl / RES().optimal));
    return Math.min(pw, want * rec.nat[0] / nl);
  }
  function renderLib(p) {
    var body = p.querySelector('.dtf-lib-body'); if (!body) return;
    var fams = families(), its = items(), count = {};
    its.forEach(function (o) { var k2 = keyOf(o); count[k2] = (count[k2] || 0) + 1; });
    p._fams = fams;
    var hc = p.querySelector('.dtf-lib-n0'); if (hc) hc.textContent = fams.length ? String(fams.length) : '';
    if (!fams.length) { body.innerHTML = '<div class="dtf-lib-empty">' + IC.lib + '<span>Designs you upload show up here, ready to reuse on any sheet.</span></div>'; return; }
    body.innerHTML = '<div class="dtf-lib-grid">' + fams.map(function (f, i) {
      var r = pickRec(f), n = 0; f.recs.forEach(function (x) { n += count[x.key] || 0; });
      var w = widthFor(r) || defaultWidth(r), name = f.root.name || r.name || 'Design';
      // print resolution at that width, and whether this version was enhanced (so the blurry original isn't re-added by mistake)
      var dpi = Math.round((r.full || r.fullUrl || r.uploading ? r.nat[0] : (r.el.naturalWidth || r.nat[0])) / Math.max(0.01, w)), enh = enhOf(r);
      var et = enh < 0 ? 'AI-upscaled' : enh ? 'enhanced' : '', q = '<small class="dtf-lib-q" title="' + esc(dpi + ' DPI at ' + fin(w) + ' wide' + (enh < 0 ? ' · rebuilt with AI from a ' + (-enh) + ' DPI file' : enh > 1 ? ' · enhanced from ' + enh + ' DPI' : '')) + '"><span class="dtf-dpi ' + bandOf(dpi) + '"><i></i>' + dpi + ' DPI</span>' + (et ? ' · ' + et : '') + '</small>';
      return '<button type="button" class="dtf-lib-it" data-li="' + i + '" title="Add a copy of ' + esc(name) + ' to this sheet">' +
        '<span class="dtf-lib-th"><img src="' + esc(r.url) + '" alt="" loading="lazy" draggable="false"></span><b>' + esc(name) + '</b>' +
        '<small>' + fin(w) + ' wide</small>' + q + (n ?'<small class="dtf-lib-cnt">×' + n + ' on this sheet</small>' : '<small class="dtf-lib-cnt dtf-lib-0">Not on this sheet</small>') + '</button>';
    }).join('') + '</div>';
    Array.prototype.forEach.call(body.querySelectorAll('img'), function (im) { im.addEventListener('error', function () { im.style.visibility = 'hidden'; }); });
  }
  async function addFromLib(f, btn, p) {
    var k = kit(), rec = pickRec(f), add = fn('addObjects') || (window.DTF && window.DTF.addObjects);
    if (!rec || !fn('makeImage') || !add) return toast('That design can’t be added right now — try uploading it again.', 'warn');
    if (busy()) return waitMsg();
    btn.disabled = true;
    try {
      if (window.DTF.ensureCanvas) window.DTF.ensureCanvas();
      var w = widthFor(rec), nl = Math.max(rec.nat[0], rec.nat[1]);
      var o = k.makeImage(rec, w ? w * nl / rec.nat[0] : rec.phys);
      var sib = sibling(rec.key);
      if (sib) ['_dtfBase', '_dtfBg', '_dtfEnh'].forEach(function (q) { if (sib[q] !== undefined && sib[q] !== null) o[q] = sib[q]; });
      else if (rec !== f.root) o._dtfBase = f.root.key;
      await add([o]);
    } catch (e) { console.warn('[dtf-pro] add from My designs', e); toast('Could not add that design: ' + (e.message || 'error'), 'warn'); }
    btn.disabled = false;
    if (live(p)) renderLib(p);
  }
  function openLib(anchor) {
    var p = el('<div class="dtf-pop dtf-libpop" role="dialog" aria-label="My designs"><div class="dtf-pop-h"><span>My designs <em class="dtf-lib-n0"></em></span><button type="button" data-x aria-label="Close">' + IC.close + '</button></div>' +
      '<div class="dtf-lib-body"></div><div class="dtf-lib-f"><span class="dtf-note">' + (('ontouchstart' in window) ? 'Tap' : 'Click') + ' a design to add a copy to this sheet — at the size you last used it.</span><button type="button" class="dtf-btn" data-lib="up">' + IC.up + 'Upload</button></div></div>');
    showPop(p, anchor);
    renderLib(p);
    if (fn('posPop') && anchor) kit().posPop(p, anchor); // re-place now that the grid is in
    var lb = document.getElementById('dtfBtnLib'); if (lb) lb.setAttribute('aria-expanded', 'true');
    p.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) return closeMine(p, true);
      if (e.target.closest('[data-lib="up"]')) { closeMine(p); if (window.DTF.pickFiles) window.DTF.pickFiles(); return; }
      var b = e.target.closest('[data-li]'); if (!b || b.disabled) return;
      var f = (p._fams || [])[+b.dataset.li]; if (f) addFromLib(f, b, p);
    });
    var first = p.querySelector('.dtf-lib-it, [data-x]'); if (first) try { first.focus({ preventScroll: true }); } catch (e2) { }
    return p;
  }
  function libBtn() {
    if (document.getElementById('dtfBtnLib')) return true;
    var img = document.getElementById('btnAddImage'); if (!img || !img.parentNode) return false;
    var b = el('<button class="sms-tool-action" id="dtfBtnLib" type="button" title="My designs: reuse anything you uploaded, on any sheet" aria-haspopup="dialog" aria-expanded="false">' + IC.lib + '<span>My designs</span></button>');
    img.parentNode.insertBefore(b, img.nextSibling);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var was = libWasOpen && e.detail > 0; libWasOpen = false; // (a pointer click on the button already closed it on pointerdown)
      if (was || (cur && cur.classList.contains('dtf-libpop') && live(cur))) { closeMine(); b.setAttribute('aria-expanded', 'false'); return; }
      openLib(b);
    });
    return true;
  }
  // phones have no left toolstrip: add My designs to the Build menu the engine opens from the bottom toolbar
  // the engine's 'dtf:buildmenu' hands over the new menu before it is placed, so it opens at its full size
  function libInBuildMenu(bp) {
    if (!bp || !bp.querySelector('[data-b="auto"]') || bp.querySelector('[data-b="lib"]')) return;
    var b = el('<button type="button" data-b="lib"><b>My designs</b><span>Reuse anything you uploaded, on any sheet</span></button>');
    b.addEventListener('click', function (ev) { ev.stopPropagation(); openLib(document.getElementById('dtfTbBuild') || b); });
    bp.appendChild(b);
  }

  // ── 4) background pre-check + select-first guard ─────────────────────────
  var bgAnchor = null;
  function stop(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
  function onBgClick(e) {
    var b = e.target.closest && e.target.closest('.sms-tool-icon[data-bg="solid"], .sms-tool-icon[data-bg="pro"], [data-bg="ai"]');
    if (!b || !dtfOn() || !kit()) return;
    var anchor = bgAnchor || b; bgAnchor = null;
    if (b._dtfBgOk) { b._dtfBgOk = 0; return; } // "Remove anyway"
    if (b._dtfGo) return;                          // the engine re-clicking after loading the original (already checked)
    if (!canvas()) return;
    var sel = selected(), one = sel.length === 1 ? sel[0] : null;
    if (!isImg(one)) { stop(e); toast(sel.length > 1 ? 'Select one design — background removal works on one design at a time.' : one ? 'Background removal works on images — select an image design.' : 'Select a design first', 'warn'); return; }
    if (b.dataset.bg === (one._dtfBg || 'none')) return; // the builder ignores a repeat of the current mode
    var R = REG(), r = fn('recOf') ? kit().recOf(one) : null, base = (one._dtfBase && R && R.get(one._dtfBase)) || r;
    if (!base) return;
    if (base.alpha && !one._dtfBox && !base.box && (base.semi || 0) < 0.04) { stop(e); askBg(b, anchor); }
  }
  function askBg(btn, anchor) {
    var p = el('<div class="dtf-pop dtf-bgpop" role="alertdialog" aria-modal="false" aria-labelledby="dtfBgQ" aria-describedby="dtfBgQd"><div class="dtf-pop-h"><span id="dtfBgQ">Background is already clear</span><button type="button" data-x aria-label="Close">' + IC.close + '</button></div>' +
      '<p id="dtfBgQd">This design already has a transparent background. Removing it again can roughen the edges.</p>' +
      '<div class="dtf-pop-f"><button type="button" class="dtf-btn" data-bgq="go">Remove anyway</button><button type="button" class="dtf-btn dtf-primary" data-bgq="keep">Keep as is</button></div></div>');
    showPop(p, anchor);
    p.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bgq],[data-x]'); if (!b) return;
      closeMine(p, b.dataset.bgq !== 'go');
      if (b.dataset.bgq === 'go') { btn._dtfBgOk = 1; btn.click(); }
    });
    var k = p.querySelector('[data-bgq="keep"]'); if (k) try { k.focus({ preventScroll: true }); } catch (e2) { }
  }

  // ── 5) resolution legend ──────────────────────────────────────────────────
  var leg = null;
  function dpiOn() { var D = Dst(); if (D && D.show) return !!D.show.dpi; var b = document.querySelector('[data-dtf-t="dpi"]'); return !!(b && b.classList.contains('on')); }
  function legendHtml() {
    var B = BAND(), R = RES(), c = function (k) { return (B[k] || BAND0[k])[0]; }, t = function (k) { return (B[k] || BAND0[k])[1]; };
    return [['opt', R.optimal + '+ ' + t('opt')], ['good', R.good + '+ ' + t('good')], ['fair', R.bad + '+ ' + t('fair')], ['low', 'under ' + R.bad + ' ' + t('low')]]
      .map(function (x) { return '<span><i style="background:' + c(x[0]) + '"></i>' + x[1] + '</span>'; }).join('<b aria-hidden="true">·</b>');
  }
  function updLegend() {
    var ck = document.getElementById('dtfCheck');
    if (!ck || !ck.parentNode) return;
    var show = !!canvas() && dtfOn() && dpiOn() && items().some(isImg) && !document.querySelector('.dtf-render');
    if (!leg) { if (!show) return; leg = el('<div class="dtf-legend dtf-legend-panel" id="dtfLegend" role="note" aria-label="Resolution colours"></div>'); leg.innerHTML = legendHtml(); }
    if (leg.previousElementSibling !== ck) ck.parentNode.insertBefore(leg, ck.nextSibling);
    leg.hidden = !show;
  }


  // ── boot ──────────────────────────────────────────────────────────────────
  function boot() {
    if (booted || !window.DTF || typeof window.DTF.kit !== 'function') return;
    booted = true;
    window.DTF.review = review;
    window.DTF.noteSent = function () { lastNote = ''; };
    window.DTF.openLibrary = function (anchor) { return openLib(anchor || document.getElementById('dtfBtnLib')); };
    document.addEventListener('contextmenu', onContext, true);
    window.addEventListener('click', onBgClick, true); // before the engine's and the builder's document listeners
    // our popovers: Escape / outside click close them; arrows move through the right-click menu
    window.addEventListener('pointerdown', function (e) {
      libWasOpen = !!(cur && live(cur) && cur.classList.contains('dtf-libpop') && e.target.closest && e.target.closest('#dtfBtnLib'));
      if (cur && live(cur) && !cur.contains(e.target) && !libWasOpen) closeMine();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (!cur) return;
      if (!live(cur)) {
        // the engine's own Escape handler (window, capture) already closed it as its current popover: don't let the
        // builder's Escape also drop the selection
        if (e.key === 'Escape' && e.defaultPrevented) { e.stopPropagation(); var op = cur._opener; cur = null; if (op && op.focus && document.contains(op)) try { op.focus({ preventScroll: true }); } catch (e0) { } return; }
        cur = null; return;
      }
      if (e.key === 'Escape') { stop(e); closeMine(cur, true); return; }
      if (cur.classList.contains('dtf-ctx') && /^(ArrowDown|ArrowUp|Home|End)$/.test(e.key)) {
        var bs = Array.prototype.slice.call(cur.querySelectorAll('button')), i = bs.indexOf(document.activeElement), n = bs.length;
        if (!n) return; e.preventDefault(); e.stopPropagation();
        i = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : e.key === 'ArrowDown' ? (i + 1) % n : (i <= 0 ? n - 1 : i - 1);
        bs[i].focus();
      }
    }, true);
    window.addEventListener('wheel', function () { if (cur && cur.classList.contains('dtf-ctx')) closeMine(); }, { capture: true, passive: true });
    window.addEventListener('resize', function () { if (cur && cur.classList.contains('dtf-ctx')) closeMine(); updLegend(); });
    window.addEventListener('blur', function () { if (cur && cur.classList.contains('dtf-ctx')) closeMine(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-dtf-t]')) setTimeout(updLegend, 0);
    });
    document.addEventListener('dtf:buildmenu', function (e) { libInBuildMenu(e.detail); });
    (function mount(n) { if (!libBtn() && n < 40) setTimeout(function () { mount(n + 1); }, 250); })(0);
    setInterval(function () { updLegend(); var lb = document.getElementById('dtfBtnLib'); if (lb && !(cur && live(cur) && cur.classList.contains('dtf-libpop'))) lb.setAttribute('aria-expanded', 'false'); }, 700);
    updLegend();
  }
  window.DTFPro = { review: review, families: families };
  if (window.DTF && window.DTF.kit) boot(); else document.addEventListener('smn:ready', function () { setTimeout(boot, 0); }, { once: true });
  document.addEventListener('dtf:ready', function () { boot(); K = null; kit(); updLegend(); });
})();
